<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Diagnóstico</h4>
    <hr />

    <DataTable
      :data="diagnosticos"
      :columns="[
        { label: 'Código',        field: 'codigo' },
        { label: 'Nombre',        field: 'nombre' },
        { label: 'Clasificación', field: 'clasDiagNombre' },
      ]"
      idField="idDiagnostico"
      mensajeVacio="No hay registros de diagnósticos."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="false"
      :mostrarEliminar="esAdmin"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idDiagnostico)"
      @delete="row => deleteDiagnostico(row.idDiagnostico)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoDiagnostico.idDiagnostico" disabled />
                </div>
              </div>
            </div>
            <!-- Clasificación -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Clasificación</label></div>
                <div class="col-10">
                  <select class="form-select" v-model="datoDiagnostico.idClasDiag">
                    <option disabled value="">Seleccione...</option>
                    <option
                      v-for="clasDiag in clasDiags"
                      :value="clasDiag.idClasDiag"
                      :key="clasDiag.idClasDiag"
                    >
                      {{ clasDiag.codigo }} {{ clasDiag.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Código -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Código</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoDiagnostico.codigo"
                    style="text-transform:uppercase"
                  />
                </div>
              </div>
            </div>
            <!-- Nombre -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    v-model="datoDiagnostico.nombre"
                    style="text-transform:uppercase"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarDiagnostico"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarDiagnostico"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      diagnosticos:    [],
      datoDiagnostico: {},
      titulo:          "",
      btnCrear:        false,
      btnEditar:       false,
      modalWindow:     true,
      clasDiags:       [],
      idPerfil:        0,
    };
  },
  computed: {
    esAdmin() {
      const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
      return idPerfil === 1;
    }
  },
  mounted() {
    this.idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchClasDiags();
  },
  methods: {
    getData() {
      api.get("/vwdiagnosticos")
        .then(r => { this.diagnosticos = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar diagnósticos:", e));
    },
    validarForm() {
      return validarForm(
        this.datoDiagnostico,
        ["idClasDiag", "codigo", "nombre"],
        ["idClasDiag", "codigo", "nombre"]
      );
    },
    async guardarDiagnostico() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/diagnosticos", this.datoDiagnostico);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Diagnóstico creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarDiagnostico() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/diagnosticos", this.datoDiagnostico);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Diagnóstico actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteDiagnostico(idDiagnostico) {
      const confirm = await Swal.fire({
        title: "¿Eliminar registro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/diagnosticos/" + idDiagnostico);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    abrirModalCrear() {
      this.modalWindow     = true;
      this.datoDiagnostico = {};
      this.titulo          = "Crear Diagnóstico";
      this.btnCrear        = true;
      this.btnEditar       = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idDiagnostico) {
      this.modalWindow = true;
      this.titulo      = "Editar Diagnóstico";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp           = await api.get("/vwdiagnosticos/" + idDiagnostico);
        this.datoDiagnostico = resp.data;
      } catch (e) {
        console.error("Error al cargar diagnóstico:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    async fetchClasDiags() {
      try {
        const r      = await api.get("/vwclasdiags");
        this.clasDiags = r.data;
      } catch (e) {
        console.error("Error fetching clasDiags:", e.response?.data || e.message);
      }
    },
  },
};
</script>